import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1b19e0a4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "marquee" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<h1 class=\"span_slider_wrap\" data-v-1b19e0a4><div class=\"_p span_slider_wrap_txt\" data-v-1b19e0a4>Where Imagination runs wild  </div><div class=\"_g span_slider_wrap_txt\" data-v-1b19e0a4>Where Imagination runs wild  </div></h1><h1 class=\"span_slider_wrap\" data-v-1b19e0a4><div class=\"_p span_slider_wrap_txt\" data-v-1b19e0a4>Where Imagination runs wild  </div><div class=\"_g span_slider_wrap_txt\" data-v-1b19e0a4>Where Imagination runs wild  </div></h1>", 2)
const _hoisted_4 = [
  _hoisted_2
]
const _hoisted_5 = /*#__PURE__*/_createStaticVNode("<section class=\"campaign\" data-v-1b19e0a4><div class=\"cmp\" data-v-1b19e0a4><div class=\"sect_1\" data-v-1b19e0a4><h1 data-animation=\"paragraph\" data-v-1b19e0a4>Create Your Unique Style</h1><p data-animation=\"paragraph\" data-v-1b19e0a4> We are creating a new campaign (Project Style Your Uniqueness) to enable our customers choose what look, style or theme their crocs will look like. </p><div class=\"btn\" data-v-1b19e0a4><button data-v-1b19e0a4>Style Crocs</button></div></div></div><div class=\"cmp\" data-v-1b19e0a4><div class=\"sect_2\" data-v-1b19e0a4><canvas data-animation=\"matter-drop\" data-v-1b19e0a4></canvas></div></div></section>", 1)

import { onMounted } from "@vue/runtime-core";
import { fallSync } from "../animations/matter/fall";

export default /*#__PURE__*/_defineComponent({
  __name: 'campaign',
  setup(__props) {

const m = [
     "https://res.cloudinary.com/dszdgdeoh/image/upload/v1664456175/heart_faluri.svg",
     "https://res.cloudinary.com/dszdgdeoh/image/upload/v1664456088/svg4_fygbt8.svg",
     "https://res.cloudinary.com/dszdgdeoh/image/upload/v1664456083/svg1_giz97q.svg",
     "https://res.cloudinary.com/dszdgdeoh/image/upload/v1664456083/Paint_kirpol.svg",
     "https://res.cloudinary.com/dszdgdeoh/image/upload/v1664456083/svg5_oltkfa.svg",
     "https://res.cloudinary.com/dszdgdeoh/image/upload/v1664456083/svg2_ksaich.svg",
     "https://res.cloudinary.com/dszdgdeoh/image/upload/v1664456083/svg3_x2dtzt.svg",
];
onMounted(() => {
     const elem = document.querySelector<HTMLElement>(".campaign")!;
     fallSync(elem, m);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        onMouseover: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$store.dispatch('pauseMarquee'))),
        onMouseleave: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$store.dispatch('playMarquee'))),
        class: "span_slider"
      }, _hoisted_4, 32)
    ]),
    _hoisted_5
  ], 64))
}
}

})